import angular from 'angular';
import '@/Factories/stateHelper';
import {AdminUserRole, WebshopRootScope} from "@/models";
import {INotificationService} from "@core/Notification";

export const registerGuard = (app: IModule) => {
    app.run([
        '$rootScope',
        '$transitions',
        'StateHelperFactory',
        'Notification',
        ($rootScope: WebshopRootScope, $transitions, stateHelperFactory, notification: INotificationService) => {
            $transitions.onStart({},
                async (trans) => {
                    const toState = trans.to();
                    const fromPage = trans.from();
                    const {stateService} = trans.router;

                    // Checking access
                    const user = await $rootScope.getLoggedInUser();
                    const isLoggedIn = !!user?.Id;

                    // Already logged, not allow to access /account/login
                    if (isLoggedIn && toState.name === 'account_login') {
                        notification.showInfo('Already logged in as ' + user.Name);
                        const targetState = stateHelperFactory
                            .getNameByLink(user.Role === AdminUserRole.Cashier ? '/instoreorder' : '/');

                        return stateService.target(targetState);
                    }

                    if (!!toState.data?.allowAnonymous) {
                        return;
                    }

                    if (!isLoggedIn && toState.name !== 'account_login') {
                        $rootScope.returnUrl = toState.name;
                        notification.showMessage({
                            text: 'You are not logged in yet.'
                        });

                        return stateService.target(stateHelperFactory.getNameByLink('/account/login'));
                    }

                    if (toState.name != fromPage.name) {
                        $rootScope.setPageTitle(null);
                    }
                    
                    // Cashier is not allowed to access /instoreorder
                    if (user.Role === AdminUserRole.Cashier && toState.name !== 'instoreorder') {
                        return stateService.go('instoreorder');
                    }

                    if (toState.data?.roles?.length) {
                        if (!$rootScope.checkUserInRoles(toState.data.roles)) {
                            //console.log('You have no permission to access page: ', toState.name)
                            notification.showMessage({
                                text: 'You have no permission to access page.'
                            });

                            return stateService.go(stateHelperFactory.getNameByLink('/'));
                        }
                    }
                });

            $transitions.onSuccess({}, function (trans) {
                const toPage = trans.to();
                //const fromPage = trans.from();
                //console.log(`Page changed from ${fromPage.name || 'null'} to ${toPage.name}`);

                const body = angular.element(document.body);
                const currentClass = body.attr('class') || '';
                // Remove all old ui-page--*
                const cleanClass = currentClass.replaceAll(/(^|\s)ui-page--\S+/g, '').trim();
                // Add new class
                const pageClass = `ui-page--${toPage.name.toLowerCase().replaceAll('_', '-')}`;
                body.attr('class', cleanClass).addClass(pageClass);

                //document.title = toPage.name;
                window.scrollTo(0, 0);
            });
        }
    ]);

    return app;
}